import { MisModel } from "../../interfaces/ActionStartResponse";
import { iUser } from "../../interfaces/iUser";
import { FormatReportDateTimeJSON } from "../../Logic/DateTimeFormatters";
import { misReportFilter } from "./interfaces";
import { CallEmsApi, iEmsApiResponseBody, CallEmsApiForBlob } from "../../Logic/EmsAPI/FetchExtension";
import { productivityReport, slaReport, summaryReport, misReport, MISModelResponse } from "./interfaces";

export async function GetProductivityReportData(
    filters: summaryReport,
): Promise<iEmsApiResponseBody<productivityReport>> {
    let mofidiedFilters = { ...filters };
    mofidiedFilters.serviceCentres = []; // we adding this override becayse based on discussions with Wazeer on 3 Nov 2025 service center filter should not be applied
    return await CallEmsApi<any>("POST", "Reporting/GetProductivityReportData", mofidiedFilters);
}

export async function GetUsers(): Promise<iEmsApiResponseBody<{ users: iUser[] }>> {
    return await CallEmsApi<any>("GET", "Users");
}

export async function GetDepartments(): Promise<iEmsApiResponseBody<{ items: { id: number; name: "string" }[] }>> {
    return await CallEmsApi<any>("GET", "Departments");
}

export async function GetSLAReportData(
    filters: summaryReport,
): Promise<iEmsApiResponseBody<{ responseCycleSLAReportData: Array<slaReport> }>> {
    let mofidiedFilters = { ...filters };
    mofidiedFilters.serviceCentres = []; // we adding this override becayse based on discussions with Wazeer on 3 Nov 2025 service center filter should not be applied
    return await CallEmsApi<any>("POST", "Reporting/GetResponseCycleSLAReportData", filters);
}
export async function GetSLACSVReportData(
    filters: summaryReport,
): Promise<iEmsApiResponseBody<{ responseCycleSLADetailedReportData: Array<slaReport> }>> {
    let mofidiedFilters = { ...filters };
    mofidiedFilters.serviceCentres = []; // we adding this override becayse based on discussions with Wazeer on 3 Nov 2025 service center filter should not be applied
    return await CallEmsApi<any>("POST", "Reporting/GetResponseCycleSLADetailedReportData", filters);
}

export async function getMisModel(mailboxID: number): Promise<iEmsApiResponseBody<{ misModel: MisModel }>> {
    return await CallEmsApi<any>("GET", `Mailboxes/${mailboxID}/MISModel`);
}

export async function GetMisDownloadReportData(filters: misReportFilter): Promise<iEmsApiResponseBody<any>> {
    let modifiedFilters = { ...filters };
    modifiedFilters.dateFrom = FormatReportDateTimeJSON(filters.dateFrom.toString());
    modifiedFilters.dateTo = FormatReportDateTimeJSON(filters.dateTo.toString());

    modifiedFilters.serviceCentres = []; // we adding this override becayse based on discussions with Wazeer on 3 Nov 2025 service center filter should not be applied

    return await CallEmsApiForBlob<any>("POST", "Reporting/DownloadMisReportFile", modifiedFilters);
}

export async function GetMisReportData(
    filters: summaryReport,
): Promise<iEmsApiResponseBody<{ results: Array<misReport> }>> {
    let modifiedFilters = { ...filters };
    modifiedFilters.serviceCentres = []; // we adding this override becayse based on discussions with Wazeer on 3 Nov 2025 service center filter should not be applied
    return await CallEmsApi<any>("POST", "Reporting/GetMisReportData", modifiedFilters);
}

export async function GetMISbyMailboxKey(mailboxKey: number): Promise<iEmsApiResponseBody<MISModelResponse>> {
    return await CallEmsApi<any>("GET", `Mailboxes/${mailboxKey}/MISModel`);
}
